/**
 * Account Service
 * Handles account-related API calls (bootstrap, subscription)
 */

import apiClient from './apiClient';

/**
 * Bootstrap user account
 * Initializes or retrieves user account data from backend
 * Creates user document in Firestore if it doesn't exist
 * @returns {Promise<{user: object, subscription: object}>} User profile and subscription
 */
export async function bootstrap() {
  const response = await apiClient.post('/account/bootstrap');
  console.log('Bootstrap response:', response);
  return response;
}

/**
 * Get subscription status for current user
 * @returns {Promise<object>} Subscription status and period bounds
 */
export async function getSubscription() {
  const response = await apiClient.get('/account/subscription');
  return response;
}

/**
 * Get invoices for current user's Stripe customer
 * @param {number} limit - Maximum number of invoices to return (default: 12, max: 50)
 * @returns {Promise<Array>} Array of invoice objects
 */
export async function getInvoices(limit = 12) {
  const response = await apiClient.get('/account/invoices', {
    params: { limit }
  });
  return response;
}

export const accountService = {
  bootstrap,
  getSubscription,
  getInvoices
};

export default accountService;
